import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import memberService from '../../../../src/services/member';
import { MemberAttributeType } from '../../../types/member';
import AddressStep from './AddressStep';
import PaymentStep from './PaymentStep';
import { jsx as _jsx } from "react/jsx-runtime";
var State;

(function (State) {
  State["LOADING"] = "LOADING";
  State["ADDRESS"] = "ADDRESS";
  State["PAYMENT"] = "PAYMENT";
})(State || (State = {}));

var Order = function Order(_ref) {
  var userId = _ref.userId,
      plan = _ref.plan,
      order = _ref.order,
      cardOnFile = _ref.cardOnFile,
      redirectURL = _ref.redirectURL,
      initOrderPayment = _ref.initOrderPayment,
      createSubscription = _ref.createSubscription,
      verifyPayment = _ref.verifyPayment,
      getServiceCustomersByUserIdAndServiceId = _ref.getServiceCustomersByUserIdAndServiceId,
      createBooking = _ref.createBooking,
      getOrder = _ref.getOrder,
      updateOrder = _ref.updateOrder;

  var _useState = useState(State.LOADING),
      state = _useState[0],
      setState = _useState[1]; // TODO: use redux if we have to, or a context, or whatever


  var _useState2 = useState(),
      setMember = _useState2[1];

  var serviceId = plan === null || plan === void 0 ? void 0 : plan.providerServiceId;
  useEffect(function () {
    if (!serviceId || !userId) return;

    if (state === State.LOADING && plan.requires_address) {
      memberService.get(serviceId).then(function (member) {
        var _member$attributes;

        setMember(member); // does member already have an address? for now we just see if there's one

        var _filter = ((_member$attributes = member.attributes) !== null && _member$attributes !== void 0 ? _member$attributes : []).filter(function (a) {
          return a.type === MemberAttributeType.ADDRESS;
        }),
            _filter2 = _slicedToArray(_filter, 1),
            address = _filter2[0];

        if (address) {
          setState(State.PAYMENT);
        } else {
          setState(State.ADDRESS);
        }
      });
    } else if (state === State.LOADING) {
      setState(State.PAYMENT);
    }
  }, [serviceId, userId, state, plan.requires_address]);
  if (state === State.LOADING) return null;
  if (state === State.ADDRESS) return /*#__PURE__*/_jsx(AddressStep, {
    serviceId: serviceId,
    reload: function reload() {
      return setState(State.LOADING);
    },
    plan: plan,
    order: order
  });
  if (state === State.PAYMENT) return /*#__PURE__*/_jsx(PaymentStep, {
    plan: plan,
    order: order,
    initOrderPayment: initOrderPayment,
    createBooking: createBooking,
    createSubscription: createSubscription,
    verifyPayment: verifyPayment,
    cardOnFile: cardOnFile,
    redirectURL: redirectURL,
    getServiceCustomersByUserIdAndServiceId: getServiceCustomersByUserIdAndServiceId,
    getOrder: getOrder,
    updateOrder: updateOrder
  });
  return null;
};

export default Order;